import { render, staticRenderFns } from "./LogoIcon.vue?vue&type=template&id=0f911e4b&scoped=true&"
import script from "./LogoIcon.vue?vue&type=script&lang=js&"
export * from "./LogoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f911e4b",
  null
  
)

export default component.exports